// extracted by mini-css-extract-plugin
export default {"container":"plate_container__uNRpa","outline":"plate_outline__O-yi5","drop-shadow":"plate_drop-shadow__QtdX9","gleam":"plate_gleam__RYWh9","bright-gleam":"plate_bright-gleam__sqc3I"};